import { trustBadges } from '@/mocks/seoContent';

export default function TrustBadges() {
  return (
    <section className="w-full bg-background-50 py-8 md:py-10">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {trustBadges.map((badge) => (
            <div key={badge.label} className="flex items-center gap-3 p-4 rounded-xl bg-background-100">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${badge.icon} text-xl text-accent-600`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}